import React, { useMemo } from 'react';
import * as css from './fakeLockedInput.module.scss';
import classNames from 'classnames';
import { Lock } from '@mui/icons-material';

interface Props {
  value?: string;
  id?: string;
  label?: string;
  containerClassName?: string;
  dataCy?: string;
  required?: boolean;
}

export const FakeLockedInput: React.FC<React.PropsWithChildren<Props>> = ({
  value = '',
  id,
  label,
  containerClassName,
  dataCy,
  required,
}) => {
  const labelStyle = useMemo(
    () => (!label || label.length === 0 ? css.noLabel : css.hasLabel),
    [label],
  );

  return (
    <p className={classNames(css.textContainer, containerClassName)}>
      <span className={classNames(css.label, labelStyle)}>
        {label} {required && <span className={css.required}>*</span>}
        <span className={css.text} title={value}>
          <span
            id={id}
            className={css.stopOverflow}
            data-cy={dataCy ? dataCy : 'locked-input'}
          >
            {value}
          </span>
          <Lock color="disabled" className={css.lock} />
        </span>
      </span>
    </p>
  );
};
